// extracted by mini-css-extract-plugin
module.exports = {"sync-button":"sync-button_sync-button__2SAAt"};